export const loadState = () => {
  try {
    const serialState = localStorage.getItem("state");
    if (serialState === null) {
      return undefined;
    }
    return JSON.parse(serialState);
  } catch (error) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    let { authReducer, userProfileReducer } = state;
    const stateToStore = JSON.stringify({ authReducer, userProfileReducer });
    localStorage.setItem("state", stateToStore);
  } catch (error) {
  }
};
